<template>
  <div class="manager">
     <Loading v-show="loading"></Loading>
  	<div id="tab">
      <ul class="tabMenu">
        <li class="tabItem" v-for="(tab,index) in tabs" v-on:click="activetab=(index+1)" v-bind:class="[ activetab === (index+1) ? 'active' : '' ]">{{tab.tabitem}}</li>
      </ul>
      <div v-if="activetab === 1">
        <h2>レシピの登録(1件ずつ)</h2>
        <div class="register-inner">
          <p class="title">レシピ名</p>
          <input v-model="register_recipe_name" placeholder="例）エビチリ">

          <p class="title">日付</p>
          <Datepicker
          :language="ja"
          class="test"
          placeholder="日付"
          :format="DatePickerFormat"
          v-model="register_recipe_date">
          </Datepicker>

          <p class="title">時間</p>
          <vue-timepicker
          :format="format"
          :minute-interval="minInterval"
          id="startDate"
          name="startDate"
          placeholder="例) 10:00am"
          hour-label="時"
          minute-label="分"
          v-model="register_recipe_time"
          />

          <p class="title">サムネイル画像</p>
          <div class="imgContent">
            <input type="file" id="input" class="file_input" name="photo" @change="onFileChange"  accept="image/*" />
            <div class="imagePreview">  
            <img :src="uploadedImage" style="width:100%;" />
            </div>
          </div>

          <p class="title">調理時間</p>
          <input v-model="register_cook_time" placeholder="例）5">

          <p class="title">カロリー</p>
          <input v-model="register_calory" placeholder="例）180">

          <p class="title">プロテイン</p>
          <input v-model="register_protein" placeholder="例）100">

          <p class="title">脂肪</p>
          <input v-model="register_fat" placeholder="例）60">

          <p class="title">糖質</p>
          <input v-model="register_carbs" placeholder="例）20">

           <!--材料入力フォーム-->
          <p class="title">材料　<button v-on:click="addIngredient()">+</button></p>
          <div class="recipe-inner" v-for="ingredient of ingredients"  :key="ingredient">
            <div class="recipe-input-form">
              <button class="removeButton" v-on:click="removeIngredient(ingredient.position)">-</button>
              <p class="title">材料名　<input class="ingredient_name" placeholder="例）セロリ" v-model="ingredient.name"></p>
              <p class="title">分量　<input class="ingredient_amount" placeholder="例）2" v-model="ingredient.amount"><select v-model="ingredient.amountUnit">
                <option value="0">個</option>
                <option value="1">グラム</option>
                <option value="2">リットル</option>
              </select></p>
              <p class="title">カロリー　<input class="ingredient_calory" placeholder="例）102.3" v-model="ingredient.calory"></p>
              <p class="title">タンパク質　<input class="ingredient_protein" placeholder="例）23.3" v-model="ingredient.protein"></p>
              <p class="title">脂肪　<input class="ingredient_fat" placeholder="例）11.8" v-model="ingredient.fat"></p>
              <p class="title">糖質　<input class="ingredient_carbs" placeholder="例）2.5" v-model="ingredient.carbs"></p>
               <p class="title">カテゴリ<select v-model="ingredient.category">
                <option value="0">果物</option>
                <option value="1">野菜</option>
                <option value="2">肉</option>
                <option value="3">魚</option>
                <option value="4">乳製品</option>
                <option value="5">穀類</option>
                <option value="6">調味料</option>
                <option value="7">その他</option>
              </select></p>
            </div>
          </div>

          <!--調理方法入力フォーム-->
          <p class="title">調理方法　<button v-on:click="addProcess()">+</button></p>
          <div class="process-inner" v-for="(item, index) in processes">
            <label> ({{ index+1 }}) </label><input class="" placeholder="例）オーブンで１分弱加熱する。" v-model="item.text"><button v-on:click="removeProcess(item.position)" class="removeButton">-</button>
          </div>

          <p class="title">レシピのおすすめ(+α)</p>
          <textarea v-model="register_recipe_reccomend" placeholder="おすすめの食べ方やテクニックなどを紹介"></textarea>

        </div>
        <button class="registerButton" type="" v-on:click="newRecipe()">新規作成</button>

      </div>
      <div class="form" v-else>
        <h2>現在記事の機能はありません。</h2>
        <!--
      	<h2>記事の登録(1件ずつ)</h2>
        <button class="registerButton" type="" v-on:click="newArticle()">新規作成</button>-->
      </div>
    </div>
  </div>
</template>
<style scoped>
*{
  box-sizing: border-box;
}
ul,li{
  margin: 0;
  padding: 0;
  list-style: none;
}
#tab{
  max-width: 60%;
  margin: 16px auto;
}

.tabMenu{
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
  list-style: none;
  border-bottom: 1px solid black;
}
.tabItem{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  flex-basis: 49%;
  flex-shrink: 0;
  border-left: 1px solid black;
  border-right: 1px solid black;
  border-top: 1px solid black;
  color: black;
  font-weight: bold;
  text-align: center;
}
.tabItem.active{
  background-color: black;
  color: #fff;
}
.imgContent {
   width: 100%;
    margin:auto;
     margin-bottom:40px;
} 
.imagePreview {
    height:auto;
    margin-top: 20px;
    background: rgb(240, 240, 240);
    overflow:hidden;
    border-radius: 10px;
    background-position: center center;
    background-size: cover;
     margin-bottom:30px;
     position: relative;
 }
 .fileUpload {
  text-align: center;
  position: absolute;
  height: 25px;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  color:rgb(134, 134, 134);
  padding: 20px;
}
.register-inner .title{
  text-align: left;
}
.register-inner {
  text-align: left;
}
.registerButton{
  display: block;
  background:black;
  color: white;
  border-radius: 50px;
  padding-top:8px;
  padding-bottom: 8px;
  padding-right: 48px;
  padding-left: 48px;
  font-size: 14px;
  margin:5% auto;
  border:0px;
}
.recipe-input-form{
  position: relative;
  background: rgb(240, 240, 240);
  padding: 8px;
  margin-top: 16px;
  margin-bottom: 16px;
}
.recipe-input-form .removeButton{
  position: absolute;
  right: 8px;
  bottom: 8px;
  background: red;
  color: white;
  border:0px;
}
.recipe-input-form p{
  display: inline-block;
}
.process-inner {
  position: relative;
  background: rgb(240, 240, 240);
  padding: 8px;
  margin-top: 16px;
  margin-bottom: 16px;
}
.process-inner .removeButton{
  position: absolute;
  right: 8px;
  bottom: 8px;
  background: red;
  color: white;
  border:0px;
}
.process-inner input{
  width: 80%;
}
.register-inner textarea {
  width: 100%;
  height: 100px;
}


@media ( max-width : 600px ){
  #tab{
  max-width: 90%;
  margin: 16px auto;
}
}

</style>
<script>
import $ from 'jquery'
import Loading from '../common/Loading'
import firebase from 'firebase'
import Datepicker from 'vuejs-datepicker'
import {ja} from 'vuejs-datepicker/dist/locale'
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'

export default {
  name: 'Manager',
  components: {
    Loading, VueTimepicker, Datepicker
  },
  data () {
    return {
      userId: null,
      db: null,
      loading: false,
      storage: null,
      activetab: 1,
      register_recipe_name: null,
      register_recipe_reccomend: null,
      register_recipe_date: null,
      register_recipe_time: null,
      register_date: null,
      uploadedImage: null,
      register_cook_time: null,
      register_calory: null,
      register_protein: null,
      register_fat: null,
      register_carbs: null,
      ingredients: [],
      processes: [],
      register_ingredients:[],
      register_processes: [],
      numberPattern: /^([1-9]\d*|0)(\.\d+)?$/,
      ja: ja,
      DatePickerFormat: 'yyyy-MM-dd',
      ormat: 'HH:mm',
      tabs: [
      { tabitem: "レシピ" },
      { tabitem: "記事" }
    ],
    contents: [
      {
        position: 0
      },
      {
        position: 1
      }
    ]
    }
  },
  methods: {
    newRecipe: function () {
      let self = this

      // 値バリデーション
      if (!this.register_recipe_name) {
        alert('レシピの名前を入力してから登録ボタンを押してください。')
        return
      }
      if (!this.register_recipe_date) {
        alert('レシピの日付を選択してから登録ボタンを押してください。')
        return
      }
      if (!this.register_recipe_time) {
        alert('レシピの時間を選択してから登録ボタンを押してください。')
        return
      }
      // ここでレシピの日付を作成
      var year  = this.register_recipe_date.getFullYear()
      var month  = this.register_recipe_date.getMonth()
      var day  = this.register_recipe_date.getDate()
      this.register_date = new Date(year, month, day, this.register_recipe_time.HH, this.register_recipe_time.mm, 0)

      if (!this.uploadedImage) {
        alert('レシピのサムネイル画像を選択してから登録ボタンを押してください。')
        return
      }
      if (!this.register_cook_time) {
        alert('レシピの調理時間を入力してから登録ボタンを押してください。')
        return
      }
      // 半角数字かどうか
      if (!this.numberPattern.test(this.register_cook_time)) {
          alert('レシピの調理時間の入力が正しくありません。レシピの調理時間は半角数字で入力してください')
          return
      }
      if (!this.register_calory) {
        alert('レシピのカロリーを入力してから登録ボタンを押してください。')
        return
      }
      // 半角数字かどうか
      if (!this.numberPattern.test(this.register_calory)) {
          alert('レシピのカロリーの入力が正しくありません。レシピのカロリーは半角数字で入力してください')
          return
      }
      if (!this.register_protein) {
        alert('レシピのタンパク質量を入力してから登録ボタンを押してください。')
        return
      }
      // 半角数字かどうか
      if (!this.numberPattern.test(this.register_protein)) {
          alert('レシピのタンパク質量の入力が正しくありません。レシピのタンパク質量は半角数字で入力してください')
          return
      }
      if (!this.register_fat) {
        alert('レシピの脂肪量を入力してから登録ボタンを押してください。')
        return
      }
      // 半角数字かどうか
      if (!this.numberPattern.test(this.register_fat)) {
          alert('レシピの脂肪量の入力が正しくありません。レシピの脂肪量は半角数字で入力してください')
          return
      }
      if (!this.register_carbs) {
        alert('レシピの糖質量を入力してから登録ボタンを押してください。')
        return
      }
      if (!this.numberPattern.test(this.register_carbs)) {
          alert('レシピの糖質量の入力が正しくありません。レシピの糖質量は半角数字で入力してください')
          return
      }
      if (this.ingredients.length === 0) {
        alert('レシピの材料を最低一つは入力してから登録ボタンを押してください。')
        return
      } else {
        // 個数分、入力が正確にされているか確認
        for (let n = 0; n < this.ingredients.length; n++) {
          // バリデーション
          var ingredient = this.ingredients[n]
          var position = n + 1
          if (ingredient.name.length === 0) {
            alert(position + '番目のレシピの材料の名前を入力してから登録ボタンを押してください。')
            return
          }
          if (!ingredient.amount) {
            alert(position + '番目のレシピの材料の量を入力してから登録ボタンを押してください。')
            return
          }
          if (!this.numberPattern.test(ingredient.amount)) {
            alert(position + '番目のレシピの材料の量の入力が正しくありません。レシピの材料の量は半角数字で入力してください')
            return
          }
          if (!ingredient.calory) {
            alert(position + '番目のレシピの材料のカロリーを入力してから登録ボタンを押してください。')
            return
          }
          if (!this.numberPattern.test(ingredient.calory)) {
            alert(position + '番目のレシピの材料のカロリーの入力が正しくありません。レシピの材料のカロリーは半角数字で入力してください')
            return
          }
          if (!ingredient.protein) {
            alert(position + '番目のレシピの材料のプロテインを入力してから登録ボタンを押してください。')
            return
          }
          if (!this.numberPattern.test(ingredient.protein)) {
            alert(position + '番目のレシピの材料のプロテインの量の入力が正しくありません。レシピの材料のプロテインの量は半角数字で入力してください')
            return
          }
          if (!ingredient.fat) {
            alert(position + '番目のレシピの材料の脂肪の量を入力してから登録ボタンを押してください。')
            return
          }
          if (!this.numberPattern.test(ingredient.fat)) {
            alert(position + '番目のレシピの材料の脂肪の量の入力が正しくありません。レシピの材料の脂肪の量は半角数字で入力してください')
            return
          }
          if (!ingredient.carbs) {
            alert(position + '番目のレシピの材料の糖質の量を入力してから登録ボタンを押してください。')
            return
          }
          if (!this.numberPattern.test(ingredient.carbs)) {
            alert(position + '番目のレシピの材料の糖質の量の入力が正しくありません。レシピの材料の糖質の量は半角数字で入力してください')
            return
          }
          if (!ingredient.category) {
            alert(position + '番目のレシピの材料のカテゴリを選択してから登録ボタンを押してください。')
            return
          }

          //　材料と調理方法を登録用に精査
          var hash = {}
          hash['name'] = ingredient.name
          hash['amount'] = parseFloat(ingredient.amount)
          hash['unit'] = parseInt(ingredient.amountUnit, 10)
          hash['calory'] = parseFloat(ingredient.calory)
          hash['protein'] = parseFloat(ingredient.protein)
          hash['fat'] = parseFloat(ingredient.fat)
          hash['carbs'] = parseFloat(ingredient.carbs)
          hash['category'] = parseInt(ingredient.category, 10)
          this.register_ingredients.push(hash)
          
        }

      }
      if (this.processes.length === 0) {
        alert('レシピの調理方法を最低一つは入力してから登録ボタンを押してください。')
        return
      } else {
        // 個数分、入力が正確にされているか確認
        for (let n = 0; n < this.processes.length; n++) {
          // バリデーション
          var p = this.processes[n]
          var position = n + 1
          if (p.text.length === 0) {
            alert(position + '番目のレシピの調理方法を入力してから登録ボタンを押してください。')
            return
          }

          //　材料と調理方法を登録用に精査
          this.register_processes.push(p.text)
          
        }
      }

      if (this.register_recipe_reccomend.length === 0) {
        alert('レシピのおすすめを入力してから登録ボタンを押してください。')
        return
      } 



      this.loading = true

      // サムネイル画像をFireStorageへ登録
      var file =  document.getElementById('input').files[0]
      var filePath = 'recipes/' + file.name
      var thumnailImgRef = this.storage.ref().child(filePath)
      thumnailImgRef.put(file).then(function(snapshot) {
        // サムネイル画像URLとその他情報を新規保存
        self.registerRecipeClass(filePath)
      });
    },
    registerRecipeClass: function (path) {
      // レシピクラスに保存する
      let self = this
      var recipeDoc = {
          carbs: parseFloat(this.register_carbs),
          date: this.register_date,
          fat: parseFloat(this.register_fat),
          fav: [],
          ingredients: this.register_ingredients,
          kcal: parseFloat(this.register_calory),
          name: this.register_recipe_name,
          preparation: this.register_processes,
          protein: parseFloat(this.register_protein),
          recommend: this.register_recipe_reccomend,
          time: parseFloat(this.register_cook_time),
          thumbnail: path,
          createDate: Date()
        }
        let collection = this.db.collection('recipes')
        collection.add(recipeDoc).then(function (docRef) {
          self.loading = false
          alert('レシピ登録完了')
          // 更新
          self.register_processes = []
          self.register_ingredients = []
          self.processes = []
          self.ingredients = []
          location.href = '/manager'

        }).catch(function (error) {
          self.loading = false
          alert('サーバーエラーでレシピをアップロードできませんでした。')
        })

    },
    updateRecipe: function () {
    },
    deleteRecipe: function () {
    },
    newArticle: function () {
      alert('現在まだ実装できておりません。もうしばらくお待ちください！')
    },
    updateArticle: function () {
    },
    deleteArticle: function () {
    },
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      this.createImage(files[0]);
    },
    createImage(file) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.uploadedImage = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    addIngredient: function () {
      var hash = {}
      hash["position"] = this.ingredients.length
      hash["name"] = ''
      hash["calory"] = 0
      hash["protein"] = 0
      hash["fat"] = 0
      hash["carbs"] = 0
      hash["amount"] = 0
      hash["amountUnit"] = 0
      hash["category"] = 0
      this.ingredients.push(hash)
    },
    removeIngredient: function (position) {
      this.ingredients.splice(position,1);
    },
    addProcess: function () {
      var hash = {}
      hash["position"] = this.processes.length
      hash["text"] = ''
      this.processes.push(hash)
    },
    removeProcess: function (position) {
      this.processes.splice(position,1);
    }
  },
  created: function () {
    let self = this
    this.db = firebase.firestore()
    this.storage = firebase.storage()
  },
  mounted : function(){
  }
}
</script>


// WEBPACK FOOTER //
// src/components/manager/Manager.vue